// FoundingBadge — visual recognition for is_founding_member users.
// Promise made in Option A copy: "badge Founding Member — for life".
//
// Sizes:
//   xs  → just the bee icon (8px) for inline use next to a name
//   sm  → bee + "Founding" pill, dense list rows
//   md  → bee + full label + tooltip-style sub, profile headers

export default function FoundingBadge({ user, size = 'sm', lang = 'en', style }) {
  if (!user?.is_founding_member) return null;
  const fr = lang === 'fr';

  if (size === 'xs') {
    return (
      <span
        title={fr ? 'Founding Member' : 'Founding Member'}
        style={{
          display:'inline-flex', alignItems:'center', justifyContent:'center',
          width:14, height:14, fontSize:10, lineHeight:1,
          background:'rgba(201,168,76,0.18)', color:'#C9A84C',
          borderRadius:'50%', flexShrink:0, border:'0.5px solid rgba(201,168,76,0.4)',
          ...style,
        }}>
        ✦
      </span>
    );
  }

  if (size === 'md') {
    return (
      <div style={{
        display:'inline-flex', alignItems:'center', gap:6,
        padding:'4px 10px', borderRadius:99,
        background:'rgba(201,168,76,0.12)',
        border:'1px solid rgba(201,168,76,0.35)',
        color:'#C9A84C',
        fontSize:11, fontWeight:600, letterSpacing:'0.06em', textTransform:'uppercase',
        fontFamily:"'Outfit', system-ui, sans-serif",
        ...style,
      }}>
        <span>✦</span>
        <span>{fr ? 'Founding Member' : 'Founding Member'}</span>
      </div>
    );
  }

  // size === 'sm' (default)
  return (
    <span style={{
      display:'inline-flex', alignItems:'center', gap:4,
      padding:'2px 7px', borderRadius:99,
      background:'rgba(201,168,76,0.14)',
      border:'1px solid rgba(201,168,76,0.32)',
      color:'#C9A84C',
      fontSize:9, fontWeight:600, letterSpacing:'0.05em', textTransform:'uppercase',
      fontFamily:"'Outfit', system-ui, sans-serif",
      flexShrink:0,
      ...style,
    }}>
      <span>✦</span>
      <span>{fr ? 'Founding' : 'Founding'}</span>
    </span>
  );
}
